import { render } from "./CharlaMobile.vue?vue&type=template&id=bcedf1bc&scoped=true"
import script from "./CharlaMobile.vue?vue&type=script&lang=js"
export * from "./CharlaMobile.vue?vue&type=script&lang=js"

import "./CharlaMobile.vue?vue&type=style&index=0&id=bcedf1bc&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcedf1bc"]])

export default __exports__